import { render, staticRenderFns } from "./FormControlMBasketOrdersInternalEmailMessageId.vue?vue&type=template&id=90a87f50"
import script from "./FormControlMBasketOrdersInternalEmailMessageId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMBasketOrdersInternalEmailMessageId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports